import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useFormElement } from '../../composables/useFormElement';
import { makeUseFormElementEmits, makeUseFormElementProps } from '../../composables/useFormElementInterfaces';
import { FieldModel } from '../../interfaces';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckboxMultipleFormField',
  props: makeUseFormElementProps<FieldModel, string[]>(),
  emits: makeUseFormElementEmits<string[]>(),
  setup(__props, { emit }) {

const props = __props;





const formElement = useFormElement({
  emit,
  props,
});

const { modelStateRef, model, field, setValue } = formElement;

const fieldValue = computed(() => (Array.isArray(field.value.$model) ? field.value.$model : []));

const options = modelStateRef('options');

function optionName(option: any) {
  return typeof option === 'string' ? option : option.label;
}

function optionValue(option: any) {
  return typeof option === 'string' ? option : option.value;
}

function isChecked(option: any) {
  return fieldValue.value.includes(optionValue(option));
}

function onChange(option: any, $event: Event) {
  const checked = !!($event.target as any).checked;
  const value = optionValue(option);
  const model = [...value.value];
  if (checked && !isChecked(option)) {
    model.push(value);
  } else if (!checked && isChecked(option)) {
    model.splice(model.indexOf(value), 1);
  }
  setValue(model);
}

return { __sfc: true,props, emit, formElement, modelStateRef, model, field, setValue, fieldValue, options, optionName, optionValue, isChecked, onChange }
}

})